<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h3>APS Intake</h3></app-anchor
	>
	<h3 class="flex-1">/ Edit Lawyer</h3>
</div>

<app-container type="dark" class="mt-2">
	<app-create-employee-side-form
		(onSubmit)="onSubmit($event)"
		(onCancel)="onCancel()"
		[minify]="false"
		[employee]="employee"
		[company]="firm"
		checkboxLabel="Same as firm"
	>
	</app-create-employee-side-form>
</app-container>
